export default {
  AS: {
    "footer.button.billOfMaterials": "Stykliste",
    "footer.button.export": "Eksport",
    "footer.button.printPdf": "PDF",
    "footer.button.contactSales": "Salg Kontakt",
    "footer.button.addToWatchlist": "Tilføj til huskeliste",
    "footer.button.requestQuote": "Anmod om tilbud",
    "header.configurator.title": "Konfigurator",

    "header.links.about.label": "Om asecos",
    "header.links.about.url":
      "https://www.asecos.com/About-asecos/About-asecos/About-asecos/EN_index_3187.html",
    "header.links.terms.label": "AGB",
    "header.links.terms.url":
      "https://www.asecos.com/GTS-asecos-AB/SE_index_1724.html",
    "header.links.imprint.label": "Impressum",
    "header.links.imprint.url":
      "https://www.asecos.com/Imprint/SE_index_1438.html",
    "header.links.privacy.label": "Databeskyttelsespolitik",
    "header.links.privacy.url":
      "https://www.asecos-configurator.com/DA/DK/Databeskyttelseshenvisninger",

    "dialog.requestQuote.title.success": "Forespørgsel sendt",
    "dialog.requestQuote.title.requestQuote": "Anmod om tilbud",
    "tab.billOfMaterials.title": "Stykliste",
    "tab.configurationSummary.title": "Sammenfatning af konfigurationen",
    "dialog.requestQuote.title.contactData": "Kontaktoplysninger",
    "dialog.requestQuote.title.companyData": "Firmaoplysninger",
    "dialog.requestQuote.label.salutation": "Tittel",
    "dialog.requestQuote.select.salutation.option.female": "Fru",
    "dialog.requestQuote.select.salutation.option.male": "Hr.",
    "dialog.requestQuote.select.salutation.option.none": "--",

    "dialog.requestQuote.label.firstName": "Fornavn",
    "dialog.requestQuote.label.lastName": "Efternavn",
    "dialog.requestQuote.label.email": "E-mail",
    "dialog.requestQuote.label.phone": "Telefon",
    "dialog.requestQuote.label.company": "Firma",
    "dialog.requestQuote.label.country": "Land",
    "dialog.requestQuote.label.postalCode": "Postnummer",
    "dialog.requestQuote.label.city": "By",
    "dialog.requestQuote.label.street": "Gade",
    "dialog.requestQuote.label.number": "Nr.",
    "dialog.requestQuote.label.contactHours": "Jeg beder om at blive ringet op",
    "dialog.requestQuote.checkbox.contactHours.option.morning": "Formiddag",
    "dialog.requestQuote.checkbox.contactHours.option.afternoon": "Eftermiddag",
    "dialog.requestQuote.label.specialistRetailer.header":
      "Her kan du indtaste din foretrukne forhandler (hvis denne er kendt)",

    "dialog.requestQuote.label.specialistRetailer.salutation": "Tittel",
    "dialog.requestQuote.select.specialistRetailer.salutation.option.female":
      "Fru",
    "dialog.requestQuote.select.specialistRetailer.salutation.option.male":
      "Hr.",
    "dialog.requestQuote.select.specialistRetailer.salutation.option.none":
      "--",
    "dialog.requestQuote.label.specialistRetailer.company": "Firma",
    "dialog.requestQuote.label.specialistRetailer.firstName": "Fornavn",
    "dialog.requestQuote.label.specialistRetailer.lastName": "Efternavn",
    "dialog.requestQuote.label.specialistRetailer.email": "E-mail",
    "dialog.requestQuote.label.specialistRetailer.city": "By",
    "dialog.requestQuote.url.privacyPolicy":
      "https://www.asecos-configurator.com/DA/DK/Databeskyttelseshenvisninger",
    "dialog.requestQuote.url.consentForm":
      "https://www.asecos-configurator.com/EN/DK/media/DOK_EXT_Einwilligungserklaerung-asecos-Konfigurator_IN?sprache=EN",
    "dialog.requestQuote.label.readPrivacyPolicy":
      "Jeg har læst<privacyLink>oplysningerne om databeskyttelse </privacyLink> gog accepterer dem. Desuden giver jeg iht <consentLink> samtykkeerklæringen</consentLink> mit samtykke til behandling, brug og videregivelse af mine data til en forhandler.",
    "dialog.requestQuote.label.comment": "Kommentar",
    "SubconfigurationNavigation.resetItem": "Nulstil gruppe",
    "SubconfigurationNavigation.previousItem": "Tilbage",
    "SubconfigurationNavigation.nextItem": "Videre",
    "form.field.error.email": "E-mail ugyldig",
    "form.field.error.phone": "Telefonnummer ugyldigt",
    "validation.required": "Dette felt er obligatorisk",
    "footer.button.save": "Gem",
    "footer.button.load": "Indlæs",

    "dialog.requestQuote.success.message":
      "Mange tak for din interesse i asecos og vores produkter. Du modtager inden for de næste par minutter en bekræftelse på den angivne e-mailadresse med dine konfigurationsdata som PDF- og JSON-fil. Med sidstnævnte kan du åbne din konfiguration igen via upload-knappen. \n\nasecos-produkter sælges via autoriserede forhandlere. Derfor videresender vi din forespørgsel til en passende asecos-partner. Denne vil udarbejde et uforpligtende tilbud i henhold til din konfiguration og om nødvendigt kontakte dig yderligere.",
    "dialog.requestQuote.success.close": "Luk",
    "dialog.requestQuote.error.message":
      "Der opstod en fejl under afsendelsen af din forespørgsel. Prøv igen senere.",
  },
};
